import axios from "axios";
import Tippy from "@tippyjs/react";
import excelIcon from "../../../images/icons/excel 1 (1).png";
import Swal from "sweetalert2";
import { useState } from "react";

const ExcelDownload = (props) => {
  const [loading, setLoading] = useState(false);
  const download = async () => {
    setLoading(true);
    if (!props?.validate || props.validate(props.filter)) {
      try {
        let response = await axios.post(
          props.url,
          {
            ...props.filter,
            paginate: 0,
            download: 1,
            is_active: 1,
            branch_id:
              props.filter?.branch_id ||
              JSON.parse(localStorage.getItem("inventory"))?.userData
                ?.branch_data?.[0]?.branch_id,
          },
          {
            headers: {
              Authorization:
                "Bearer " +
                JSON.parse(localStorage.getItem("inventory"))?.token,
            },
            responseType: "arraybuffer",
          }
        );
        setLoading(false);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", props.filename + ".xlsx");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        Swal.fire("", "Error While Downloading");
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Tippy content="Download" trigger="mouseenter">
        {loading ? (
          <span className="spinner-border spinner-border-sm"></span>
        ) : (
          <img
            src={excelIcon}
            className="img-fluid mx-2 icon"
            width="30px"
            height="30px"
            alt=""
            role="button"
            onClick={(e) => download()}
          />
        )}
      </Tippy>
    </>
  );
};

export default ExcelDownload;
